import * as React from 'react';
import useReduxState from 'src/hooks/useReduxState';

import AlertHeader from './AlertHeader';
import AlertTabListing from './AlertTabListing';

export function Alert() {

    const [selectedTab] = useReduxState('', 'searchParams')

    return (
        <>
            <div className="content-box container-fluid maxw100 api-request-content">

                <AlertHeader selectedTab={selectedTab}/>

                <AlertTabListing />

            </div>
        </>
    );

}
